



/**
 * Adds a signature field to each element in the ABI array.
 * This standalone function works without external dependencies.
 * In a production environment, use ethers.js or web3.js for proper keccak256 implementation.
 * 
 * @param {Array} abi - The ABI array from a smart contract
 * @return {Array} - A new ABI array with added signature fields
 */
function addSignaturesToABI(abi) {
  return abi.map(item => {
    const result = { ...item }; // Create a copy of the item
    
    // Generate signatures for functions and events
    if (item.type === 'function' || item.type === 'event') {
      // Create the canonical signature format: name(type1,type2,...)
      const name = item.name;
      const types = (item.inputs || []).map(input => input.type).join(',');
      const signature = `${name}(${types})`;
      
      result.signature = signature;
      
      // In a production environment, you would replace these with actual keccak256 hashing:
      // const hash = ethers.utils.keccak256(ethers.utils.toUtf8Bytes(signature));
      // OR const hash = web3.utils.keccak256(signature);
      
      if (item.type === 'function') {
        // In a real implementation, this would be the first 4 bytes of the keccak256 hash
        // For demonstration, we'll use a placeholder
		result.signatureString=signature
        result.signature = `0x${getFunctionSelector(signature)}`;
      } else if (item.type === 'event') {
        // In a real implementation, this would be the full keccak256 hash
        // For demonstration, we'll use a placeholder
		result.signatureString=signature
        result.signature = `0x${getEventTopic(signature)}`;
      }
    } 
    // Special cases
    else if (item.type === 'constructor') {
      const types = (item.inputs || []).map(input => input.type).join(',');
      result.signature = `constructor(${types})`;
    }
    else if (item.type === 'fallback') {
      result.signature = 'fallback()';
    }
    else if (item.type === 'receive') {
      result.signature = 'receive()';
    }
    
    return result;
  });
}

/**
 * A very simple string hash function to generate a pseudo function selector
 * NOT FOR PRODUCTION USE - this is not the actual Ethereum keccak256 algorithm
 * @param {string} str - Function signature string
 * @return {string} - 8 character hex string (4 bytes)
 */
function getFunctionSelector(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  // Make sure it's positive and take 8 hex chars (4 bytes)
  return (hash >>> 0).toString(16).padStart(8, '0');
}

/**
 * A very simple string hash function to generate a pseudo event topic
 * NOT FOR PRODUCTION USE - this is not the actual Ethereum keccak256 algorithm
 * @param {string} str - Event signature string
 * @return {string} - 64 character hex string (32 bytes)
 */
function getEventTopic(str) {
  // This is just a demonstration - real keccak256 should be used
  let result = '';
  let hash = 0;
  
  // Generate a pseudo-random 64 character hex string
  for (let i = 0; i < 64; i++) {
    hash = (hash + str.charCodeAt(i % str.length) + i) % 16;
    result += hash.toString(16);
  }
  
  return result;
}

// Example usage:
// const abi = [...your ABI array...];
// const enhancedABI = addSignaturesToABI(abi);
// console.log(JSON.stringify(enhancedABI, null, 2));


module.exports=addSignaturesToABI